import type { ComponentProps } from 'react';

import { clsxm } from '@vs-shop/utils';
import { ImageOff } from 'lucide-react';

export type ImageMissingPlaceholderProps = ComponentProps<typeof ImageOff>;

export function ImageMissingPlaceholder({ className, ...props }: ImageMissingPlaceholderProps) {
  return (
    <ImageOff
      data-slot="image-missing-placeholder"
      className={clsxm('text-neutral size-[50%] shrink-0', className)}
      {...props}
    />
  );
}
